import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import tw from 'tailwind-styled-components'

export const ModalWrapper = styled.div<{ fullScreen?: boolean }>`
  color: white;
  width: 100%;
  margin: 0 auto;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  max-width: 1248px;
  height: ${props => props.fullScreen ? '100vh' : 'auto'};
`

export const ModalHeader = tw.div`
  relative p-20 bg-darkBrown
`

export const LeftIconWrapper = tw.div`
  absolute left-0 top-1/2 transform -translate-y-1/2 ml-14
`

export const ModalHeading = tw.h2`
  text-eucalyptus text-xl font-bold text-center
`

export const CloseIcon = styled.div`
  margin-right: 14px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`

export const ModalBody = styled.div<{ fullScreen?: boolean }>`
  ${({ fullScreen }) => !fullScreen && `
    background-color: #17181B;
    border: 1px solid #292b32;
    border-radius: 7px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
  flex: 1;
  overflow-y: auto;
  height: calc(100vh - 80px);

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const customModalStyles = (width: string, fullScreen: boolean) => ({
  content: {
    top: fullScreen ? '0' : '50%',
    left: fullScreen ? '0' : '50%',
    right: fullScreen ? '0' : 'auto',
    bottom: fullScreen ? '0' : 'auto',
    transform: fullScreen ? 'none' : 'translate(-50%, -50%)',
    width: fullScreen ? '100%' : width,
    height: fullScreen ? '100%' : 'auto',
    maxWidth: '100%',
    padding: 0,
    border: 'none',
    borderRadius: fullScreen ? '0' : '8px',
    backgroundColor: fullScreen ? 'rgba(27, 29, 30, 0.96)' : '#1B1D1E',
    animation: fullScreen ? 'modalFadeIn 0.2s ease-out' : 'modalFadeInCenter 0.2s ease-out'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    zIndex: 1000,
    animation: 'overlayFadeIn 0.2s ease-out'
  },
})